import { FC, useCallback } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import history from '@app/services/history';
import clsx from 'clsx';

const useStyles = makeStyles<any>()({
  root: {
    cursor: 'pointer',
  },
  text: {
    color: '#4B4B4B',
    textDecoration: 'underline',
    '&.small': {
      fontSize: '12px',
    },
    '&.medium': {
      fontSize: '15px',
    },
    '&.large': {
      fontSize: '18px',
    },
  },
});

const ActionLink: FC<any> = ({
  icon = null,
  children,
  onClick,
  uri,
  size = 'small',
}) => {
  const { classes } = useStyles(null);

  const onInternalClick = useCallback(() => {
    history.push(uri);
  }, [uri]);

  return (
    <Box
      alignItems="center"
      className={classes.root}
      display="flex"
      onClick={onClick || onInternalClick}
    >
      {icon && (
        <Box alignItems="center" display="flex" mr={1}>
          {{
            ...icon,
            props: {
              width: icon.props.width || 12,
              height: icon.props.height || 12,
              stroke: '#B6B6B6',
            },
          }}
        </Box>
      )}
      <Box
        alignItems="center"
        className={clsx(classes.text, size)}
        display="flex"
      >
        {children}
      </Box>
    </Box>
  );
};

// Some predefined buttons that used often

const ActionLinkEdit: FC<any> = (props) =>
  ActionLink({
    ...props,
    icon: <i className="ri-pencil-line" style={{ fontSize: 14 }} />,
  });
const ActionLinkBack: FC<any> = (props) =>
  ActionLink({
    ...props,
    size: 'medium',
    icon: <i className="ri-arrow-left-s-line" style={{ fontSize: 25 }} />,
  });
const ActionLinkAdd: FC<any> = (props) =>
  ActionLink({
    ...props,
    icon: <i className="ri-add-line" style={{ fontSize: 24 }} />,
  });
const ActionLinkRemove: FC<any> = (props) =>
  ActionLink({
    ...props,
    icon: <i className="ri-close-circle-line" style={{ fontSize: 24 }} />,
  });

export {
  ActionLink,
  ActionLinkEdit,
  ActionLinkBack,
  ActionLinkAdd,
  ActionLinkRemove,
};
